import React from 'react';
import styled from 'styled-components';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { useTranslations } from '@libs/translations';
import { Points } from '@styles';

export const InternalNavigation = () => {
  const translations = useTranslations();
  const itemsList = translations.t('site.home.internalNav.navListAi').split(',');

  const handleClick = (event) => {
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    ) {
      return;
    }

    try {
      const href = event.currentTarget.getAttribute('href');
      const targetId = href && href.slice(1);
      const targetSection = targetId && document.getElementById(targetId);

      if (targetSection) {
        event.preventDefault();

        targetSection.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });

        window.history.pushState(null, '', href);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const itemsLinks = [
    '#beginning-project',
    '#visualization-concept',
    '#neural-network',
    '#virtual-tour',
    '#working-documentation',
    '#final-touch',
  ];
  return (
    <View id="internal-navigation">
      <Container>
        <Description dangerouslySetInnerHTML={{ __html: translations.t('site.home.internalNav.description') }} />
        <NavWrapper>
          <NavList>
            {itemsList.map((item, index) => (
              <NavItem key={index}>
                <NavLink href={itemsLinks[index]} onClick={handleClick}>
                  {item}
                </NavLink>
              </NavItem>
            ))}
          </NavList>
        </NavWrapper>
      </Container>
    </View>
  );
};

const View = styled.section`
  padding: 20px 10px;
  background-color: ${Colors.main_black};
  color: ${Colors.white};

  @media ${Points.tablet_landscape} {
    padding: 34.5px 74.5px;
  }

  @media ${Points.laptop_wide} {
    padding: 30px auto;
  }
`;

const Container = styled.div`
  @media ${Points.laptop_wide} {
    margin: auto;
    width: fit-content;
  }
`;

const Description = styled.div`
  font-size: 16px;
  line-height: 1.3;
  text-align: center;

  @media ${Points.tablet_landscape} {
  }

  @media ${Points.laptop_wide} {
    width: 875px;
    font-size: 18px;
  }
`;

const NavWrapper = styled.nav`
  margin: 15px 18px 0;
`;

const NavList = styled.ul`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 5px;
  margin: 0;
  padding-inline-start: 0;
  list-style: none;

  @media ${Points.tablet_landscape} {
    flex-direction: row;
    gap: 26px;
  }
`;

const NavItem = styled.li`
  min-height: 33px;
  position: relative;
  width: 100%;
  max-width: 320px;

  @media ${Points.tablet_landscape} {
    width: auto;
    max-width: auto;

    &:not(:last-child)::after {
      position: absolute;
      top: 50%;
      right: -5px;
      transform: translateX(100%) translateY(-50%);
      content: '';
      display: block;
      width: 16px;
      height: 16px;
      background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'%3e%3cpath d='M3 8L13 8' stroke='%234A4A4A' stroke-linecap='round' stroke-linejoin='round'/%3e%3cpath d='M9 3L14 8L9 13' stroke='%234A4A4A' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e");
    }
  }
`;

const NavLink = styled.a`
  display: block;
  padding: 5px 10px;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 25px;
  text-align: center;
  text-decoration: none;
  color: ${Colors.white};
  font-size: 18px;
  line-height: 1.3;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: rgba(255, 255, 255, 0.12);
  }
`;
